// extracted by mini-css-extract-plugin
export default {"lineButtons":"realEstateItem_lineButtons__H33cm","headers":"realEstateItem_headers__kGENZ","twoInLine":"realEstateItem_twoInLine__ta-EK"};